angular.module("vgresiduos").controller("MasterOrganizationListCtrl", [
	"$rootScope",
	function ($rootScope) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, `master/organizacoes`);
		};
	}
]);
